(function () {

	angular
		.module('ngmvac')
		.filter('orderByPromoAG', OrderByPromoAG);

	function OrderByPromoAG() {
		return function (hotels) {
			var orderedHotels = hotels.sort(function (firstHotel, secondHotel) {
				if (firstHotel.promoMCR && secondHotel.promoMCR) {
					if (firstHotel.minRatePublica < secondHotel.minRatePublica) {
						return -1;
					} else {
						return 1;
					}
					
					return 0;
				}

				if (firstHotel.promoMCR) {
					return -1;
				}

				if (secondHotel.promoMCR) {
					return 1;
				}

				return 0;
			});

			return orderedHotels;
		}
	}

})();